import { ZuersZoneEnum } from '@ps20-frontend/frontend-models';
import { IAppState } from '../../../store/appState';
import { PlzRequiresUwStatus } from '../../../store/reducers/plzRequiresUw.reducer';

export const selectPlzRequiresUwStatus = (state: IAppState): PlzRequiresUwStatus =>
  state.plzRequiresUw;

export const selectPlzRequiresUwIsAnswered = (state: IAppState): boolean =>
  typeof state.plzRequiresUw === 'boolean';

export const selectPlzRequiresUw = (state: IAppState): boolean => state.plzRequiresUw === true;

export const selectPlzRequiresUwAnswerIsRelevant = (state: IAppState): boolean =>
  state.elementarSelbstbehalt?.id === ZuersZoneEnum.DREI;
